import { z } from "zod";
import {
    accrualMatchAuditSnapshotSchema,
    ACCRUAL_MATCH_DIFF_FIELD,
} from "@common/schemas/domains/accrualReview/accrual-match-audit-log.schema";

export { ACCRUAL_MATCH_DIFF_FIELD };

type AccrualMatchAuditSnapshotParsed = z.infer<
    typeof accrualMatchAuditSnapshotSchema
>;

export function parseAccrualMatchSnapshot(
    value: unknown,
): AccrualMatchAuditSnapshotParsed | null {
    if (value == null) {
        return null;
    }
    const result = accrualMatchAuditSnapshotSchema.safeParse(value);
    if (!result.success) {
        return null;
    }
    return result.data;
}
